import React, {PureComponent} from 'react';

import {toMap} from '../../lib/helpers';
import Button from '../../components/Button';
import SideModal from '../../components/SideModal';
import Form from '../../components/Form';
import Input from '../../components/Input';
import {getDateRangeLabel} from './SheetDateRange';

import Filter from './Filter';
import {isQuestionDeleted} from "../FormBuilderScreen/shared";

class SheetRowFilter extends PureComponent {
  state = {
    filters: this.props.filters ? this.props.filters.filters : [],
    validations: {},
    reviewState: this.props.filters ? this.props.filters.reviewState : ''
  };

  handleFilterChange = filter => {
    this.setState(prevState => ({
      filters: [
        ...prevState.filters.filter(f => f.questionId !== filter.questionId),
        filter
      ].filter(f => f.operator !== null),
      validations: Object.keys(prevState.validations).filter(key => key !== filter.questionId).reduce((map, key) => {
        map[key] = prevState.validations[key];
        return map;
      }, {})
    }));
  }

  handleApplyFilters = () => {
    const {template, onApplyFilters} = this.props;
    const {filters, reviewState} = this.state;
    // The date range is set on the page by SheetDateRange, so whatever it applied is kept.
    const minDate = this.props.filters ? this.props.filters.minDate : null;
    const maxDate = this.props.filters ? this.props.filters.maxDate : null;
    const questionsById = toMap([...template.contextQuestions, ...template.questions], question => question.id);
    const validations = filters.reduce((map, filter) => {
      const messages = Filter.validate(questionsById[filter.questionId], filter);

      if (messages.length > 0) {
        map[filter.questionId] = messages;
      }

      return map;
    }, {});

    this.setState({validations});

    if (Object.keys(validations).length > 0) {
      // There was validation issues, so we won't apply any filters.
      return;
    }

    onApplyFilters({and: true, minDate, maxDate, reviewState, filters});
  }

  // The date range lives on the page, not in this panel, so it is kept. Choosing "All time" there is how it is cleared.
  handleClearFilters = () => {
    this.setState({reviewState: '', filters: [], validations: {}});
  }

  render() {
    const {template, catalog, open, onClose, showDeleted} = this.props;
    const {filters, validations, reviewState} = this.state;
    const filtersByQuestionId = toMap(filters, filter => filter.questionId);
    const questions = [...template.contextQuestions].sort((a, b) => a.order - b.order)
      .concat([...template.questions].sort((a, b) => a.order - b.order))
      .filter(question => question.type !== 'IMAGE' && question.type !== 'SIGNATURE');
    const dateRangeLabel = getDateRangeLabel(this.props.filters);

    return (
      <Form onSubmit={this.handleApplyFilters}>
        <SideModal
          title="Filter Data"
          open={open}
          onClose={onClose}
          options={[
            <Button type="submit">Apply Filters</Button>,
            <Button secondary onClick={this.handleClearFilters}>Clear Filters</Button>
          ]}>
          <SideModal.Content>
            {dateRangeLabel && (
              <Form.Group>
                Showing data from: {dateRangeLabel}
              </Form.Group>
            )}
            {template.reviewers.length > 0 && (
              <Form.Group>
                <Input
                  id="filter_review_state"
                  label="Review Status"
                  type="select"
                  value={reviewState}
                  onChange={e => this.setState({reviewState: e.target.value})}>
                  <option value="">All</option>
                  <option value="PENDING">Pending</option>
                  <option value="IN_REVIEW">In Review</option>
                  <option value="APPROVED">Approved</option>
                  <option value="REJECTED">Rejected</option>
                </Input>
              </Form.Group>
            )}
            {(!showDeleted ? questions.filter(question => !isQuestionDeleted(question)) : questions).map(question => (
              <Form.Group key={question.id}>
                <Filter
                  question={question}
                  catalog={catalog}
                  filter={filtersByQuestionId[question.id] || emptyFilter(question)}
                  onChange={this.handleFilterChange}
                  validations={validations[question.id] || []}
                />
              </Form.Group>
            ))}
          </SideModal.Content>
        </SideModal>
      </Form>
    );
  }
}

function emptyFilter(question) {
  return {
    questionId: question.id,
    operator: null,
    values: []
  };
}

export default SheetRowFilter;

